export const SIDEBAR_EXPANDED_PX = 240;
export const SIDEBAR_COLLAPSED_PX = 92;
